export default __webpack_public_path__ + "static/media/LAS0110.34I-41199_-24564_0.5d24e44d.jpg";